import type { Event } from "~/calendar/CalendarPage";

/**
 * @param event The event in question.
 * @returns Whether the event can be edited, and if not, why. The reason can be displayed to the user.
 */
export default function isEventEditable(event: Event): { canEdit: boolean; reason?: string } {
	if (event.timeBlockType === "focusTime") {
		return {
			canEdit: false,
			reason: "Focus time events cannot be edited.",
		};
	}
	if (event.timeBlockType === "outOfOffice") {
		return {
			canEdit: false,
			reason: "Out of office events cannot be edited.",
		};
	}
	if (event.status === "cancelled") {
		return {
			canEdit: false,
			reason: "Cancelled events cannot be edited.",
		};
	}
	if (!event.isOrganizer) {
		return {
			canEdit: false,
			reason: "Only the event organizer can edit this event.",
		};
	}
	return {
		canEdit: true,
	};
}
